const variables = {
  fullStarColor: '#c4d600',
  emptyStarColor: '#ffffff',
  strokeColor: '#c4d600',
};

export default variables;



// WEBPACK FOOTER //
// ./src/aria/variables.js